import TreatmentSelect from './_TreatmentSelect';

export default TreatmentSelect;
